define([
	"dojo/_base/declare",
	"csi/core/ExtendedPath",
	"csi/heading/RefFilterController",
	"csi/prefs/BrowseAttributesStore",
	"csi/reflection",
	"MaterialSpecProductSpec/ProductTypeAttributeStoreOptions"
], function(declare, ExtendedPath, RefFilterController, BrowseAttributesStore, reflection, ProductTypeAttributeStoreOptions) {

	return declare(RefFilterController, {
		getAttributesStore: function() {
			// summary: return store filled with Material and MaterialAttributes attributes

			// get the material type config of the current PSPlacement.
			var startType = "Material";
			var options = this._getStoreOptions("Child:MaterialType/Child:ProductionConfig");
			var store = new BrowseAttributesStore(reflection.getClass(startType), options);

			// add items from MaterialAttributes at the same level as Material
			var path = new ExtendedPath(startType);
			path.addRelationStep("Attributes");
			store.addTopLevelItemsFromPath(path);

			return store;
		},

		getRelativeAttributesStore: function() {
			// summary: return store filled with Style, StyleAttributes, StyleAttributes.Tool, StyleAttributes.Tool.MaterialAttributes

			// get the material type config from the tool of the ProductStructure.
			// It is always the first item in 'Placements' attribute of ProductStructure
			var startType = "Style";
			var options = this._getStoreOptions("Child:__Parent__/Child:Placements/Index:0/Child:MaterialType/Child:ProductionConfig");
			var store = new BrowseAttributesStore(reflection.getClass(startType), options);

			// add items from Attributes - StyleAttributes
			var path = new ExtendedPath(startType);
			path.addRelationStep("Attributes");
			store.addTopLevelItemsFromPath(path);

			// add items from Spec path - MaterialSpecification class
			path = new ExtendedPath(startType);
			path.addRelationStep("Spec");
			store.addTopLevelItemsFromPath(path);

			// add items from Spec/Tool path - Material class
			path = path.clone();
			path.addRelationStep("Tool");
			store.addTopLevelItemsFromPath(path);

			// add items from Spec/Tool/Attributes path - MaterialAttributes class
			path = path.clone();
			path.addRelationStep("Attributes");
			store.addTopLevelItemsFromPath(path);

			return store;
		},

		_getStoreOptions: function(/*String*/path) {
			// summary: get store options for material type at end of path
			var config = this.getCache().getPathNode(this.getNode(), path, true);
			return new ProductTypeAttributeStoreOptions(config.AttributesMap);
		}
	});
});